const Header: React.FC<{ logoMobile: string; logoDesktop: string }> = ({
  logoMobile,
  logoDesktop,
}) => {
  return (
    <div className="w-full flex justify-center md:mt-6 mt-2">
      <div className="bg-white w-[25%] sm:w-[15%] md:w-[219px] aspect-[219/165] rounded-[20px] sm:rounded-[25px] flex items-center justify-center shadow-md sm:shadow-lg p-4">
        <img
          alt="Logo"
          src={`${logoMobile}`}
          sizes="(max-width: 640px) 100vw, 50vw"
        />
      </div>
    </div>
  );
};
export default Header;
